import React from 'react';

export const CheckboxCircleGray300UncheckedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
        stroke="#DCDCDC"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
